export default function isMailLink(url) {
  return !!url && url.includes("mailto:");
}
